// KHO MẪU (09/10/2026, docs/thiet-ke-kho-mau.md đợt 1) — Boss chọn mẫu theo MỤC TIÊU → "Cài đặt cơ bản" (vài ô Super mở + sản phẩm + bot + giờ chạy)
// → Tạo → trang kịch bản (chế độ đơn giản: Cài đặt cơ bản ở đầu, sơ đồ thu gọn trong "Chỉnh chi tiết"). Super: "Sửa hiển thị" trên thẻ mẫu của mình.
//   #/kho-mau          renderKhoMau      — thẻ theo nhóm; Boss: Dùng mẫu; Super: Sửa hiển thị (hộp hopCaiDat)
//   #/kho-mau/:id      renderKhoMauMot   — form Cài đặt cơ bản → POST /api/kho-mau/:id/tao (+ POST /api/kich-ban/:id/lich nếu chọn giờ) → #/kich-ban/:id?botIds=…
//   theCoBan(box, id)  — thẻ "Cài đặt cơ bản" trên trang kịch bản tạo từ Kho mẫu (GET/PUT /api/kich-ban/:id/co-ban + tóm tắt lịch)
// Mọi chữ dựng bằng textContent (h()). Kiểm từng ô ở trình duyệt bằng loiMotO (src/shared/kho-mau.ts) — máy chủ kiểm lại đủ (cùng luật bộ kiểm sơ đồ).
import { api, ApiError, buildQuery, errMsg } from "../api";
import { busy, clear, confirmBox, dongHopTrang, gen, h, toast } from "../dom";
import { isSuper, loadBots, store } from "../store";
import { diToi } from "../ngan-truot";
import type { Bot } from "../types";
import { dienThongKe, oThongKe } from "./kho-mau-thong-ke";
import { NHOM_MAU, O_TOI_DA, RUI_RO_MAU, loiMotO, type CaiDatMau, type OCoBan, type OGoiY, type RuiRoMau } from "../../../../src/shared/kho-mau";
import { dungKhungGioAi } from "../khung-gio-ai";
import { GIAN_CACH_LICH_MAU_S, GIO_THAP_DIEM_MAC_DINH, LECH_LICH_MAU_PHUT } from "../../../../src/shared/gio-cao-diem";
import { MUC_DO, MUC_DO_MAC_DINH, coMucDo, giaTriMuc, mucKhop, type MucDo } from "../../../../src/shared/kho-mau";
import type { GoiDungTomTat, GoiView } from "../types"; // đợt 3c: nhóm "Gói nhiều mạng" (GET /api/goi-seeding + /api/goi-seeding/dung)

type OXem = Omit<OCoBan, "gan">;
interface MauThe { id: string; nhom: string; tenHien: string; moTa: string; ruiRo: RuiRoMau | null; nenTang: string[]; soBuoc: number; soO: number; dangDung: number; phienBan: number }
interface MauChiTiet { id: string; nhom: string; tenHien: string; moTa: string; ruiRo: RuiRoMau | null; nenTang: string[]; soBuoc: number; o: OXem[]; buoc: string[]; sanPhamMau: { ten: string; thuVien: boolean } | null; banCuaToi: { kichBanId: string; ten: string }[] }
interface CoBan { mau: { id: string; tenHien: string; conHieuLuc: boolean }; theoMau?: boolean; o: OXem[]; giaTri: Record<string, string>; sanPham: { id: string; ten: string } | null; boQua?: string[]; veMacDinh?: string[] }
interface LichXem { id: string; hhmm: string; enabled: boolean; thu?: number[]; cheDo: string; botTen: string[] }

const TEN_MANG: Record<string, string> = { facebook: "Facebook", tiktok: "TikTok", youtube: "YouTube", x: "X", reddit: "Reddit" };
const THU = [{ v: 1, t: "T2" }, { v: 2, t: "T3" }, { v: 3, t: "T4" }, { v: 4, t: "T5" }, { v: 5, t: "T6" }, { v: 6, t: "T7" }, { v: 7, t: "CN" }];
const LOP_RUI_RO: Record<RuiRoMau, string> = { thap: "ok", vua: "warn", cao: "err" };
const GIO = /^([01]\d|2[0-3]):[0-5]\d$/;
const KHOA_YC = (mauId: string) => `kho-mau-yc:${mauId}`;
const maYeuCau = (): string => `km-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
function ycCua(mauId: string): string {
  // Mã yêu cầu giữ qua F5 (sessionStorage): bấm Tạo lại sau khi tải lại trang = CÙNG một kịch bản. Hỏng / chặn bộ nhớ → mã mới (vẫn chống bấm đúp).
  try { const c = sessionStorage.getItem(KHOA_YC(mauId)); if (c) return c; const m = maYeuCau(); sessionStorage.setItem(KHOA_YC(mauId), m); return m; } catch { return maYeuCau(); }
}
function boYc(mauId: string): void { try { sessionStorage.removeItem(KHOA_YC(mauId)); } catch { /* bỏ qua */ } }

const tagRuiRo = (r: RuiRoMau | null): HTMLElement | null => (r ? h("span", { class: `tag ${LOP_RUI_RO[r]}`, "data-testid": "kho-mau-rui-ro" }, `Rủi ro ${RUI_RO_MAU[r]}`) : null);
const tagMang = (ds: string[]): HTMLElement[] => ds.map((m) => h("span", { class: "tag" }, TEN_MANG[m] ?? m));

/** Ô nhập cho một ô cơ bản + dòng lỗi ngay dưới. Số dùng ô chữ (inputmode số) để người gõ "10 bài" vẫn thấy lời nhắc thay vì ô im lặng. */
function oNhap(o: OXem, giaTri: string, testId: string): { el: HTMLElement; lay: () => string; baoLoi: (m: string | null) => void } {
  const id = `o-${testId}-${o.khoa}`;
  const input: HTMLInputElement | HTMLSelectElement = o.luaChon?.length
    ? h("select", { id }, ...(o.batBuoc ? [] : [h("option", { value: "" }, "— để trống —")]), ...o.luaChon.map((c) => h("option", { value: c, selected: c === giaTri }, c)))
    : h("input", { id, type: "text", value: giaTri, ...(o.kieu === "so" ? { inputmode: "numeric" } : {}), autocomplete: "off" });
  const loi = h("div", { class: "small err km-o-loi", "data-testid": "km-o-loi", hidden: true });
  const goiY = o.kieu === "so" && (o.min !== undefined || o.max !== undefined) ? ` (${o.min ?? "…"}–${o.max ?? "…"})` : "";
  const el = h("div", { class: "km-o", "data-testid": testId, dataset: { khoa: o.khoa } },
    h("label", { for: id }, o.nhan, goiY ? h("span", { class: "muted" }, goiY) : null, o.batBuoc ? h("span", { class: "err", title: "Bắt buộc" }, " *") : null),
    o.moTa ? h("div", { class: "small muted" }, o.moTa) : null, input, loi);
  return { el, lay: () => input.value, baoLoi: (m) => { loi.textContent = m ?? ""; loi.hidden = !m; input.setAttribute("aria-invalid", m ? "true" : "false"); } };
}

/** Kiểm mọi ô ở trình duyệt; trả giá trị (đã cắt khoảng trắng) hoặc null khi có ô sai (đã hiện lỗi dưới ô, cuộn tới ô đầu tiên sai). */
function docO(ds: { o: OXem; lay: () => string; baoLoi: (m: string | null) => void; el: HTMLElement }[]): Record<string, string> | null {
  const gt: Record<string, string> = {};
  let dau: HTMLElement | null = null;
  for (const x of ds) {
    const v = x.lay();
    const l = loiMotO(x.o, v);
    x.baoLoi(l);
    if (l) dau ??= x.el; else gt[x.o.khoa] = v.trim();
  }
  if (dau) { dau.scrollIntoView({ block: "center" }); (dau.querySelector("input,select") as HTMLElement | null)?.focus(); return null; }
  return gt;
}

/** ĐỢT 3b — khối "Mức độ" Nhẹ / Vừa / Mạnh, DÙNG CHUNG cho màn tạo (renderKhoMauMot) và thẻ "Cài đặt cơ bản" trên trang kịch bản (theCoBan).
 *  Không ô nào có mức → null (không vẽ). `mucDau` = mức chọn sẵn (null = không mức nào → hiện dòng "đã sửa số tay"); `ten` = name của nhóm radio.
 *  Đổi mức → điền ngay số của mức vào các ô CÓ mức (ô khác, kể cả ô chữ, không đụng); sửa tay ô có mức: khớp một mức → tự chọn mức đó, khác mọi mức
 *  → bỏ chọn + dòng "đã sửa số tay". Không gửi mức lên máy chủ — giá trị ô là đủ (mức hiển thị lại bằng mucKhop). */
function khoiMucDo(o: OXem[], oDs: { o: OXem; el: HTMLElement; lay: () => string; baoLoi: (m: string | null) => void }[], mucDau: MucDo | null, ten: string): HTMLElement | null {
  if (!coMucDo(o)) return null;
  const oInput = (el: HTMLElement): HTMLInputElement | null => el.querySelector("input");
  const mucRadio = MUC_DO.map((md) => h("input", { type: "radio", name: ten, value: md.ma, checked: md.ma === mucDau, "data-testid": "km-muc" }));
  const tuyChinh = h("div", { class: "small muted", "data-testid": "km-muc-tuy-chinh", hidden: mucDau !== null }, "Bạn đã sửa số tay nên không còn đúng mức nào — chọn lại một mức để điền lại số của mức đó.");
  for (const r of mucRadio) r.addEventListener("change", () => {
    if (!r.checked) return;
    const gt = giaTriMuc(o, r.value as MucDo);
    for (const x of oDs) { const v = gt[x.o.khoa]; const inp = oInput(x.el); if (v !== undefined && inp) { inp.value = v; x.baoLoi(null); } }
    tuyChinh.hidden = true;
  });
  const docHien = (): Record<string, string> => Object.fromEntries(oDs.map((x) => [x.o.khoa, x.lay()]));
  for (const x of oDs) if (giaTriMuc([x.o], MUC_DO_MAC_DINH)[x.o.khoa] !== undefined) x.el.addEventListener("input", () => {
    const dang = mucRadio.find((r) => r.checked)?.value as MucDo | undefined;
    const k = mucKhop(o, docHien(), dang);
    for (const r of mucRadio) r.checked = r.value === k;
    tuyChinh.hidden = k !== null;
  });
  return h("fieldset", { class: "km-o km-muc", "data-testid": "km-muc-ds" }, h("legend", {}, "Mức độ"),
    ...MUC_DO.map((md, i) => h("label", { class: "km-muc-chon" }, mucRadio[i]!, h("b", {}, md.ten), h("span", { class: "small muted", "data-testid": "km-muc-mo-ta" }, ` — ${md.moTa}`))),
    tuyChinh);
}

// =====================================================================================================================================
export async function renderKhoMau(root: HTMLElement): Promise<() => void> {
  const alive = gen("kho-mau");
  let choTk = new Map<string, HTMLElement>(); // đợt 3a: chỗ giữ hàng số liệu trên thẻ (Super) — điền sau một lần gọi thống kê
  // đợt 3c: hai phần độc lập — mẫu (than) và "Gói nhiều mạng" (phanGoi, luôn đứng SAU) — tải song song; lỗi phần này không đụng phần kia.
  const than = h("div", { "data-testid": "kho-mau-trang" });
  const phanGoi = h("div", { "data-testid": "kho-mau-phan-goi" });
  root.append(h("h1", {}, "Kho mẫu"),
    h("p", { class: "muted" }, isSuper()
      ? "Mẫu bạn đã cấp phát. Bấm “Sửa hiển thị” để đặt nhóm, tên, mô tả và những ô khách được chỉnh."
      : "Chọn việc bạn muốn bot làm → bấm “Dùng mẫu” → điền vài ô → Tạo. Sơ đồ chi tiết chỉ dành cho người rành."),
    than, phanGoi);
  void taiGoiNhieuMang(phanGoi, alive);
  async function tai(): Promise<void> {
    clear(than);
    than.append(h("p", { class: "muted" }, "Đang tải…"));
    let ds: { ma: string; ten: string; mau: MauThe[] }[];
    try { ds = (await api<{ nhom: { ma: string; ten: string; mau: MauThe[] }[] }>("GET", "/api/kho-mau")).nhom; }
    catch (e) {
      if (!alive()) return;
      clear(than);
      than.append(h("div", { class: "err-box", role: "alert", "data-testid": "kho-mau-loi" }, `Không tải được Kho mẫu: ${errMsg(e)}`, " ",
        h("button", { type: "button", class: "mini", "data-testid": "kho-mau-thu-lai", title: "Tải lại Kho mẫu", onclick: () => void tai() }, "Thử lại")));
      return;
    }
    if (!alive()) return;
    clear(than);
    if (!ds.length) {
      than.append(h("p", { class: "card", "data-testid": "kho-mau-trong" }, isSuper()
        ? "Bạn chưa cấp phát mẫu nào. Mở một kịch bản của bạn → ⋯ → ★ Cấp phát."
        : "Chưa có mẫu nào được cấp cho bạn. Liên hệ người quản trị (Super) để được cấp."));
      return;
    }
    choTk = new Map();
    for (const n of ds) {
      than.append(h("section", { class: "km-nhom", "data-testid": "kho-mau-nhom", dataset: { nhom: n.ma } },
        h("h2", {}, n.ten),
        h("div", { class: "km-luoi" }, ...n.mau.map((m) => theMau(m)))));
    }
    if (isSuper()) void dienThongKe(choTk, alive);
  }
  function theMau(m: MauThe): HTMLElement {
    const nut = isSuper()
      ? h("button", { type: "button", class: "pri", "data-testid": "kho-mau-sua", title: "Đặt nhóm, tên cho khách, mô tả, mức rủi ro và những ô khách được chỉnh", onclick: () => void hopCaiDat(m.id, () => void tai()) }, "Sửa hiển thị")
      : h("a", { class: "btn pri", href: `#/kho-mau/${encodeURIComponent(m.id)}`, "data-testid": "kho-mau-dung", title: "Mở màn cài đặt cơ bản của mẫu này" }, "Dùng mẫu");
    return h("article", { class: "card km-the", "data-testid": "kho-mau-the", dataset: { mauId: m.id } },
      h("h3", { "data-testid": "kho-mau-ten", class: "wrap" }, m.tenHien),
      m.moTa ? h("p", { class: "wrap", "data-testid": "kho-mau-mo-ta" }, m.moTa) : null,
      h("div", { class: "row km-tag" }, ...tagMang(m.nenTang), tagRuiRo(m.ruiRo), h("span", { class: "tag" }, `${m.soBuoc} bước`)),
      isSuper() && m.soO === 0 ? h("div", { class: "small warn", "data-testid": "kho-mau-chua-o", title: "Bấm “Sửa hiển thị” → tick các ô khách được chỉnh → Lưu" }, "Chưa có ô nào cho khách chỉnh nhanh — khách phải vào sơ đồ. Bấm “Sửa hiển thị” để mở.") : null,
      m.dangDung ? h("div", { class: "small muted", "data-testid": "kho-mau-dang-dung" }, `Bạn đang dùng: ${m.dangDung}`) : null,
      isSuper() ? oThongKe(choTk, m.id) : null,
      h("div", { class: "row end" }, nut));
  }
  await tai();
  return () => {};
}

// ---- đợt 3c: nhóm "Gói nhiều mạng" (bản nhẹ — gói KHÔNG thành mẫu; "Dùng gói" mở trình hướng dẫn gói seeding như cũ) ----
const GHI_CHU_GOI = "Tạo nhiều kịch bản + lịch một lần";
const SO_DUNG_TOI_DA = 200; // một trang "gói đã dùng" (máy chủ cho tối đa 200) — còn nữa thì ghi "N+"
let lanTaiGoi = 0;

/** Tải gói có sẵn + gói mình đã dùng (song song), vẽ vào khung. Gói lỗi → báo trong khung + Thử lại; "đã dùng" lỗi → chỉ bỏ dòng đếm. Không bao giờ ném. */
async function taiGoiNhieuMang(khung: HTMLElement, alive: () => boolean): Promise<void> {
  const lan = ++lanTaiGoi;
  clear(khung);
  khung.append(h("p", { class: "muted", "data-testid": "kho-mau-goi-cho" }, "Đang tải gói…"));
  const [rGoi, rDung] = await Promise.allSettled([
    api<{ goi: GoiView[] }>("GET", "/api/goi-seeding"),
    api<{ items: GoiDungTomTat[]; nextBefore: string | null }>("GET", `/api/goi-seeding/dung${buildQuery({ limit: SO_DUNG_TOI_DA })}`),
  ]);
  if (!alive() || lan !== lanTaiGoi) return;
  clear(khung);
  const nhom = (...con: (HTMLElement | HTMLElement[])[]) => h("section", { class: "km-nhom km-nhom-goi", "data-testid": "kho-mau-nhom-goi", dataset: { nhom: "goi" } },
    h("h2", {}, "Gói nhiều mạng"), ...con);
  if (rGoi.status === "rejected") {
    khung.append(nhom(h("div", { class: "err-box", role: "alert", "data-testid": "kho-mau-goi-loi" }, `Chưa tải được gói nhiều mạng: ${errMsg(rGoi.reason)}`, " ",
      h("button", { type: "button", class: "mini", "data-testid": "kho-mau-goi-thu-lai", title: "Tải lại danh sách gói nhiều mạng", onclick: () => void taiGoiNhieuMang(khung, alive) }, "Thử lại"))));
    return;
  }
  const ds = rGoi.value.goi;
  if (!ds.length) return; // không có gói → không có nhóm
  const daDung = new Map<string, GoiDungTomTat[]>(); // theo mã gói; máy chủ trả mới sửa trước → phần tử đầu = gần nhất
  const conNua = rDung.status === "fulfilled" && !!rDung.value.nextBefore;
  if (rDung.status === "fulfilled") for (const d of rDung.value.items) daDung.set(d.goiMa, [...(daDung.get(d.goiMa) ?? []), d]);
  khung.append(nhom(
    h("p", { class: "small muted" }, "Mỗi gói tạo sẵn nhiều kịch bản trên nhiều mạng xã hội kèm lịch chạy — chọn sản phẩm, mạng, lời văn và giờ chạy trong vài bước."),
    h("div", { class: "km-luoi" }, ...ds.map((g) => theGoiNhieuMang(g, daDung.get(g.ma) ?? [], conNua)))));
}

function theGoiNhieuMang(g: GoiView, dung: GoiDungTomTat[], conNua: boolean): HTMLElement {
  const mang = g.mang.filter((m) => m.kichBan.length);
  const soKb = mang.reduce((s, m) => s + m.kichBan.length, 0);
  const ganNhat = dung[0];
  return h("article", { class: "card km-the km-goi", "data-testid": "kho-mau-goi", dataset: { ma: g.ma } },
    h("h3", { class: "wrap", "data-testid": "kho-mau-goi-ten" }, g.ten),
    g.moTa ? h("p", { class: "wrap", "data-testid": "kho-mau-goi-mo-ta" }, g.moTa) : null,
    h("div", { class: "row km-tag" },
      ...mang.map((m) => h("span", { class: "tag", "data-testid": "kho-mau-goi-mang", title: `${m.kichBan.length} kịch bản trên ${m.ten}` }, m.ten)),
      h("span", { class: "tag", "data-testid": "kho-mau-goi-so-kb", title: "Tổng số kịch bản trong gói — khi dùng gói bạn chọn mạng và kịch bản muốn bật" }, `${soKb} kịch bản`)),
    h("div", { class: "small muted", "data-testid": "kho-mau-goi-ghi-chu" }, GHI_CHU_GOI),
    ganNhat ? h("div", { class: "small km-goi-da-dung" },
      h("span", { "data-testid": "kho-mau-goi-da-dung" }, `Bạn đã dùng: ${dung.length}${conNua ? "+" : ""}`), " · ",
      h("a", { href: `#/goi-seeding/${encodeURIComponent(ganNhat.id)}`, "data-testid": "kho-mau-goi-mo", title: `Mở gói bạn đã dùng gần nhất (${ganNhat.sanPham.ten})` }, dung.length > 1 ? "Mở gói dùng gần nhất" : "Mở gói đã dùng"),
      dung.length > 1 ? [" · ", h("a", { href: "#/goi-seeding", "data-testid": "kho-mau-goi-tat-ca", title: "Xem mọi gói bạn đã dùng" }, "Xem tất cả")] : null) : null,
    h("div", { class: "row end" },
      h("a", { class: "btn pri", href: `#/goi-seeding/moi?goi=${encodeURIComponent(g.ma)}`, "data-testid": "kho-mau-dung-goi", title: "Dùng gói này: chọn sản phẩm, mạng, lời văn, tần suất — máy tạo các kịch bản và lịch" }, "Dùng gói")));
}

// =====================================================================================================================================
export async function renderKhoMauMot(root: HTMLElement, params: Record<string, string>): Promise<() => void> {
  const alive = gen("kho-mau");
  const id = params.id ?? "";
  let m: MauChiTiet;
  try { m = await api<MauChiTiet>("GET", `/api/kho-mau/${encodeURIComponent(id)}`); }
  catch (e) {
    root.append(h("h1", {}, "Kho mẫu"), h("div", { class: "err-box", role: "alert", "data-testid": "km-loi" }, errMsg(e)), h("p", {}, h("a", { href: "#/kho-mau" }, "← Về Kho mẫu")));
    return () => {};
  }
  if (!alive()) return () => {};
  const [dsSp, bots] = await Promise.all([
    api<{ items: { id: string; ten: string }[] }>("GET", `/api/san-pham${buildQuery({ limit: 500, ownerId: store.user?.id ?? null })}`).then((r) => r.items).catch(() => null),
    loadBots().then((b) => b.filter((x) => x.ownerId === store.user?.id)).catch(() => [] as Bot[]),
  ]);
  if (!alive()) return () => {};

  root.append(h("p", { class: "small" }, h("a", { href: "#/kho-mau" }, "← Kho mẫu")),
    h("h1", { class: "wrap" }, m.tenHien),
    h("p", { class: "wrap", hidden: !m.moTa }, m.moTa),
    h("div", { class: "row km-tag" }, ...tagMang(m.nenTang), tagRuiRo(m.ruiRo), h("span", { class: "tag" }, `${m.soBuoc} bước`)),
    h("details", { class: "card km-lam-gi", "data-testid": "km-lam-gi" }, h("summary", {}, "Mẫu này làm gì"), h("ol", {}, ...m.buoc.map((b) => h("li", { class: "wrap" }, b)))));
  // tên kịch bản tự đặt đã chứa " · " (mẫu · sản phẩm) → mỗi bản một dòng, không nối bằng " · " (dễ đọc nhầm)
  if (m.banCuaToi.length) root.append(h("details", { class: "card km-lam-gi", "data-testid": "km-ban-cua-toi" }, h("summary", {}, `Bạn đã tạo ${m.banCuaToi.length} kịch bản từ mẫu này`),
    h("ul", {}, ...m.banCuaToi.map((b) => h("li", {}, h("a", { href: `#/kich-ban/${encodeURIComponent(b.kichBanId)}` }, b.ten))))));
  if (isSuper()) {
    root.append(h("p", { class: "card" }, "Đây là mẫu của bạn — Boss được cấp mới dùng được. ",
      h("button", { type: "button", class: "mini", "data-testid": "kho-mau-sua", title: "Đặt nhóm, tên cho khách, mô tả, mức rủi ro và những ô khách được chỉnh", onclick: () => void hopCaiDat(m.id, () => location.reload()) }, "Sửa hiển thị")));
    return () => {};
  }

  // ---------- form ----------
  const loiChung = h("div", { class: "err-box", role: "alert", "data-testid": "km-loi", hidden: true });
  const ten = h("input", { id: "km-ten", type: "text", "data-testid": "km-ten", maxlength: 80, placeholder: `Để trống = tự đặt (“${m.tenHien} · <sản phẩm>”)` });
  const spSel = h("select", { id: "km-sp", "data-testid": "km-san-pham" },
    h("option", { value: "" }, m.sanPhamMau ? `Dùng sản phẩm của mẫu (${m.sanPhamMau.ten})` : "— Chưa chọn sản phẩm —"),
    ...(dsSp ?? []).map((s) => h("option", { value: s.id }, s.ten)));
  // ĐỢT 3b — MỨC ĐỘ: mẫu có ô số theo mức → chọn Nhẹ / Vừa / Mạnh (mặc định Vừa) TRÊN các ô; đổi mức → điền ngay số của mức vào ô; sửa tay vẫn được
  // (khác mọi mức → "tuỳ chỉnh", khớp lại một mức → tự chọn mức đó). Máy chủ chỉ nhận giá trị ô (không gửi mức).
  const gtMuc0 = coMucDo(m.o) ? giaTriMuc(m.o, MUC_DO_MAC_DINH) : {};
  const oDs = m.o.map((o) => ({ o, ...oNhap(o, gtMuc0[o.khoa] ?? o.macDinh, "km-o") }));
  const mucBox = khoiMucDo(m.o, oDs, MUC_DO_MAC_DINH, "km-muc");
  const botChon = bots.length
    ? bots.slice().sort((a, b) => Number(b.online) - Number(a.online) || a.name.localeCompare(b.name, "vi")).map((b) => {
      const cb = h("input", { type: "checkbox", "data-testid": "km-bot", dataset: { botId: b.id }, checked: b.online, value: b.id });
      return h("label", { class: "inline km-bot" }, cb, h("span", { class: "wrap" }, b.name), h("span", { class: `small ${b.online ? "ok" : "muted"}` }, b.online ? " · trực tuyến" : " · ngoại tuyến"));
    })
    : [h("span", { class: "muted" }, "Bạn chưa có bot nào — ", h("a", { href: "#/bots" }, "ghép bot"), " trước khi chạy.")];
  const tuBam = h("input", { type: "radio", name: "km-lich", value: "tay", checked: true, "data-testid": "km-lich-tay" });
  const hangNgay = h("input", { type: "radio", name: "km-lich", value: "ngay", "data-testid": "km-lich-ngay" });
  const gioDs = h("div", { class: "row km-gio-ds" });
  const themGio = (v = ""): void => { if (gioDs.querySelectorAll("input").length >= 3) return; gioDs.append(h("input", { type: "time", value: v, "data-testid": "km-gio", "aria-label": "Giờ chạy" })); nutThemGio.hidden = gioDs.querySelectorAll("input").length >= 3; };
  const nutThemGio = h("button", { type: "button", class: "mini", "data-testid": "km-gio-them", title: "Thêm một giờ chạy nữa trong ngày (tối đa 3)", onclick: () => themGio() }, "+ Thêm giờ");
  themGio(GIO_THAP_DIEM_MAC_DINH); // giờ mặc định = THẤP điểm (AI rẻ hơn một nửa, thường nhiều tương tác hơn)
  const thuDs = h("div", { class: "row km-thu" }, ...THU.map((t) => h("label", { class: "inline" }, h("input", { type: "checkbox", "data-testid": "km-thu", value: String(t.v), checked: true }), t.t)));
  const kg = dungKhungGioAi({
    layGio: () => gioDs.querySelector("input")?.value ?? "",
    datGio: (v) => { const o = gioDs.querySelector("input"); if (o) o.value = v; },
    layThu: () => [...thuDs.querySelectorAll<HTMLInputElement>("input")].filter((c) => c.checked).map((c) => Number(c.value)),
  });
  gioDs.addEventListener("input", kg.capNhat);
  gioDs.addEventListener("change", kg.capNhat);
  thuDs.addEventListener("change", kg.capNhat);
  const lichChiTiet = h("div", { class: "km-lich-ct", hidden: true }, kg.el, gioDs, nutThemGio, thuDs,
    h("p", { class: "small muted", "data-testid": "km-gian-lich" }, `Để đỡ bị khoá nick / bắt xác minh: mỗi ngày bot chạy trễ ngẫu nhiên 0–${LECH_LICH_MAU_PHUT} phút so với giờ này, và nhiều bot cùng lịch bắt đầu lệch nhau ngẫu nhiên tới ${GIAN_CACH_LICH_MAU_S / 60} phút.`));
  const doiLich = (): void => { lichChiTiet.hidden = !hangNgay.checked; };
  tuBam.addEventListener("change", doiLich);
  hangNgay.addEventListener("change", doiLich);
  const lichLoi = h("div", { class: "small err", "data-testid": "km-lich-loi", hidden: true });
  const nutTao = h("button", { type: "submit", class: "pri", "data-testid": "km-tao", title: "Tạo kịch bản của bạn từ mẫu này (chưa chạy gì — chạy ở trang kế tiếp)" }, "Tạo kịch bản");

  const form = h("form", { class: "card km-form", "data-testid": "km-form", novalidate: true },
    h("h2", {}, "Cài đặt cơ bản"),
    loiChung,
    h("div", { class: "km-o" }, h("label", { for: "km-ten" }, "Tên"), ten),
    h("div", { class: "km-o" }, h("label", { for: "km-sp" }, "Sản phẩm"), spSel,
      dsSp && !dsSp.length ? h("div", { class: "small muted" }, "Chưa có sản phẩm nào — ", h("a", { href: "#/san-pham/moi" }, "thêm sản phẩm"), " để bình luận nhắc đúng sản phẩm của bạn.") : null),
    mucBox,
    ...oDs.map((x) => x.el),
    h("fieldset", { class: "km-o" }, h("legend", {}, "Bot chạy"), h("div", { class: "km-bot-ds" }, ...botChon)),
    h("fieldset", { class: "km-o" }, h("legend", {}, "Giờ chạy"),
      h("label", { class: "inline" }, tuBam, "Tôi tự bấm ▶ Chạy"), h("label", { class: "inline" }, hangNgay, "Hằng ngày theo giờ"), lichChiTiet, lichLoi),
    h("div", { class: "row end km-nut" }, nutTao));
  root.append(form);

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (nutTao.disabled) return; // bấm đúp: lần hai bỏ qua khi lần đầu đang gửi
    loiChung.hidden = true;
    const gt = docO(oDs);
    const botIds = [...form.querySelectorAll<HTMLInputElement>('[data-testid="km-bot"]')].filter((c) => c.checked).map((c) => c.value);
    let lich: { hhmm: string; thu: number[] }[] = [];
    lichLoi.hidden = true;
    if (hangNgay.checked) {
      const gio = [...gioDs.querySelectorAll<HTMLInputElement>("input")].map((i) => i.value.trim()).filter(Boolean);
      const thu = [...thuDs.querySelectorAll<HTMLInputElement>("input")].filter((c) => c.checked).map((c) => Number(c.value));
      const loi = !gio.length || gio.some((g) => !GIO.test(g)) ? "Nhập giờ dạng HH:MM (ví dụ 08:30)" : !thu.length ? "Chọn ít nhất một ngày trong tuần" : !botIds.length ? "Chọn ít nhất một bot để chạy theo giờ" : null;
      if (loi) { lichLoi.textContent = loi; lichLoi.hidden = false; return; }
      lich = [...new Set(gio)].map((hhmm) => ({ hhmm, thu }));
    }
    if (!gt) return;
    void busy(nutTao, "Đang tạo…", async () => {
      let kq: { kichBanId: string; daCo: boolean };
      try {
        kq = await api<{ kichBanId: string; daCo: boolean }>("POST", `/api/kho-mau/${encodeURIComponent(m.id)}/tao`,
          { yeuCauId: ycCua(m.id), giaTri: gt, ...(ten.value.trim() ? { ten: ten.value.trim() } : {}), ...(spSel.value ? { sanPhamId: spSel.value } : {}) });
      } catch (err) {
        loiChung.textContent = `Chưa tạo được: ${errMsg(err)}`;
        loiChung.hidden = false;
        loiChung.scrollIntoView({ block: "center" });
        return;
      }
      for (const l of lich) {
        try { await api("POST", `/api/kich-ban/${encodeURIComponent(kq.kichBanId)}/lich`, { hhmm: l.hhmm, thu: l.thu, botIds, cheDo: "live", enabled: true, lech: LECH_LICH_MAU_PHUT, ...(botIds.length > 1 ? { gianCachS: GIAN_CACH_LICH_MAU_S } : {}) }); }
        catch (err) { toast(`Đã tạo kịch bản nhưng chưa đặt được giờ ${l.hhmm}: ${errMsg(err)}`, "warn", 8000); }
      }
      boYc(m.id);
      toast(kq.daCo ? "Kịch bản này đã được tạo trước đó — mở lại" : "Đã tạo kịch bản — kiểm tra rồi bấm ▶ Chạy");
      diToi(`/kich-ban/${encodeURIComponent(kq.kichBanId)}${botIds.length ? `?botIds=${botIds.map(encodeURIComponent).join(",")}` : ""}`); // mở trong ngăn → thay mục lịch sử của ngăn
    });
  });
  return () => {};
}

// =====================================================================================================================================
/** Thẻ "Cài đặt cơ bản" ở đầu trang kịch bản tạo từ Kho mẫu. `sauLuu` = trang kịch bản tải lại dữ liệu (sơ đồ / bản chạy đã đổi).
 *  (Đợt 2) `khiTrangThai(theoMau)` báo trang kịch bản bản này đang THEO MẪU hay đã tách (câu nhắc trong "Chỉnh chi tiết"); null = chưa biết (tải lỗi).
 *  `lamMoiTrangThai()` chỉ đọc lại trạng thái theo mẫu / đã tách (không vẽ lại ô — không mất chữ đang gõ), dùng sau khi lưu ở phần chi tiết. */
export function theCoBan(box: HTMLElement, kichBanId: string, sauLuu: () => void, khiTrangThai?: (theoMau: boolean | null) => void): { ve: () => Promise<void>; lamMoiTrangThai: () => Promise<void> } {
  const ttBox = h("div", { class: "km-theo-mau", "data-testid": "kb-theo-mau", role: "status" });
  const ttLoi = h("div", { class: "err-box", role: "alert", "data-testid": "kb-quay-ve-loi", hidden: true });
  function veTrangThai(cb: CoBan): void {
    clear(ttBox);
    const theo = cb.theoMau !== false;
    ttBox.dataset.theoMau = theo ? "1" : "0";
    if (theo) ttBox.append(h("span", { class: "tag ok" }, "Theo mẫu"), h("span", { class: "small" }, " — tự cập nhật khi Super sửa mẫu"));
    else {
      ttBox.append(h("span", { class: "tag warn" }, "Đã tách khỏi mẫu"), h("span", { class: "small" }, " — đã chỉnh chi tiết nên không nhận cập nhật của Super. "));
      if (cb.mau.conHieuLuc) {
        const nut = h("button", { type: "button", class: "mini", "data-testid": "kb-quay-ve-mau", title: "Dựng lại từ bản mẫu mới nhất — mất các chỉnh ở “Chỉnh chi tiết”" }, "Quay về theo mẫu");
        nut.addEventListener("click", () => void quayVe(nut));
        ttBox.append(nut);
      }
    }
    khiTrangThai?.(theo);
  }
  let dangHoi = false; // bấm đúp "Quay về theo mẫu" khi hộp xác nhận đang mở → một hộp
  async function quayVe(nut: HTMLButtonElement): Promise<void> {
    if (nut.disabled || dangHoi) return;
    ttLoi.hidden = true;
    dangHoi = true;
    const ok = await confirmBox({
      title: "Quay về theo mẫu?",
      text: "Kịch bản sẽ được dựng lại từ bản mẫu MỚI NHẤT của Super, giữ các giá trị ở “Cài đặt cơ bản” và sản phẩm đang chọn.",
      nhac: "MỌI chỉnh sửa ở “Chỉnh chi tiết” (bước thêm / bớt, tham số đã đổi) sẽ MẤT và không hoàn tác được. Từ giờ kịch bản lại tự cập nhật khi Super sửa mẫu.",
      okText: "Quay về theo mẫu", danger: true,
    }).finally(() => { dangHoi = false; });
    if (!ok) return;
    await busy(nut, "Đang quay về…", async () => {
      try {
        const r = await api<CoBan>("POST", `/api/kich-ban/${encodeURIComponent(kichBanId)}/quay-ve-mau`, {});
        toast(r.veMacDinh?.length ? `Đã quay về theo mẫu — các ô về giá trị mặc định: ${r.veMacDinh.join(", ")}` : "Đã quay về theo mẫu", r.veMacDinh?.length ? "warn" : "info");
        sauLuu();
      } catch (err) { ttLoi.textContent = `Chưa quay về được: ${errMsg(err)}`; ttLoi.hidden = false; }
    });
  }
  async function lamMoiTrangThai(): Promise<void> {
    try { veTrangThai(await api<CoBan>("GET", `/api/kich-ban/${encodeURIComponent(kichBanId)}/co-ban`)); ttLoi.hidden = true; }
    catch (err) { ttLoi.textContent = `Không đọc được trạng thái theo mẫu: ${errMsg(err)}`; ttLoi.hidden = false; }
  }
  async function ve(): Promise<void> {
    let cb: CoBan;
    let lich: LichXem[] = [];
    try {
      [cb, lich] = await Promise.all([
        api<CoBan>("GET", `/api/kich-ban/${encodeURIComponent(kichBanId)}/co-ban`),
        api<{ lich: LichXem[] }>("GET", `/api/kich-ban/${encodeURIComponent(kichBanId)}/lich`).then((r) => r.lich).catch(() => []),
      ]);
    } catch (e) {
      clear(box);
      box.append(h("section", { class: "card", "data-testid": "kb-co-ban" }, h("h2", {}, "Cài đặt cơ bản"), h("div", { class: "err-box" }, `Không tải được: ${errMsg(e)}`)));
      khiTrangThai?.(null);
      return;
    }
    clear(box);
    ttLoi.hidden = true;
    veTrangThai(cb);
    const oDs = cb.o.map((o) => ({ o, ...oNhap(o, cb.giaTri[o.khoa] ?? o.macDinh, "kb-co-ban-o") }));
    // ĐỢT 3b — mức độ như màn tạo; mức ban đầu SUY từ số đang có (máy chủ không lưu mức) — khác mọi mức → không chọn + dòng "đã sửa số tay"
    const mucBox = khoiMucDo(cb.o, oDs, mucKhop(cb.o, Object.fromEntries(oDs.map((x) => [x.o.khoa, x.lay()]))), "kb-muc");
    const loi = h("div", { class: "err-box", role: "alert", hidden: true });
    const luu = h("button", { type: "submit", class: "pri", "data-testid": "kb-co-ban-luu", title: "Ghi các giá trị này vào sơ đồ của kịch bản" }, "Lưu cài đặt");
    const tenThu = (ds?: number[]): string => (!ds?.length || ds.length === 7 ? "hằng ngày" : ds.map((v) => THU.find((t) => t.v === v)?.t ?? "").filter(Boolean).join(", "));
    const lichDong = lich.length
      ? lich.map((l) => h("li", {}, `${l.hhmm} · ${tenThu(l.thu)} · ${l.botTen.join(", ")} · `, h("span", { class: l.enabled ? "ok" : "muted" }, l.enabled ? "đang bật" : "đang tắt")))
      : [h("li", { class: "muted" }, "Chưa đặt giờ — bấm ▶ Chạy khi muốn chạy, hoặc đặt giờ trong “Chỉnh chi tiết”.")];
    const form = h("form", { novalidate: true },
      loi,
      h("p", { class: "small muted" }, "Từ mẫu “", cb.mau.tenHien, "”", cb.mau.conHieuLuc ? "" : " (mẫu đã được thu hồi — kịch bản của bạn vẫn chạy bình thường)"),
      ttBox, ttLoi,
      h("div", { class: "small", "data-testid": "kb-co-ban-san-pham" }, "Sản phẩm: ", h("b", {}, cb.sanPham?.ten ?? "chưa chọn")),
      mucBox,
      ...oDs.map((x) => x.el),
      cb.o.length ? h("div", { class: "row end" }, luu) : h("p", { class: "small muted" }, "Mẫu này không có ô nào để chỉnh nhanh."),
      h("div", { class: "km-o" }, h("b", {}, "Giờ chạy"), h("ul", { "data-testid": "kb-co-ban-lich" }, ...lichDong)));
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (luu.disabled) return;
      loi.hidden = true;
      const gt = docO(oDs);
      if (!gt) return;
      void busy(luu, "Đang lưu…", async () => {
        try {
          const r = await api<CoBan>("PUT", `/api/kich-ban/${encodeURIComponent(kichBanId)}/co-ban`, { giaTri: gt });
          toast(r.boQua?.length ? `Đã lưu cài đặt — các ô không còn bước nào để áp: ${r.boQua.join(", ")}` : "Đã lưu cài đặt", r.boQua?.length ? "warn" : "info");
          sauLuu();
        } catch (err) { loi.textContent = `Chưa lưu được: ${errMsg(err)}`; loi.hidden = false; }
      });
    });
    box.append(h("section", { class: "card km-co-ban", "data-testid": "kb-co-ban" }, h("h2", {}, "Cài đặt cơ bản"), form));
  }
  return { ve, lamMoiTrangThai };
}

// =====================================================================================================================================
/** Hộp của Super: nhóm / tên cho khách / mô tả / rủi ro + tick ô cho khách chỉnh (gợi ý từ ảnh chụp mẫu). */
export async function hopCaiDat(mauId: string, sauLuu: () => void): Promise<void> {
  let goiY: OGoiY[];
  let cu: CaiDatMau | null;
  try {
    [goiY, cu] = await Promise.all([
      api<{ o: OGoiY[] }>("GET", `/api/kb-mau/${encodeURIComponent(mauId)}/goi-y-o`).then((r) => r.o),
      api<CaiDatMau | null>("GET", `/api/kb-mau/${encodeURIComponent(mauId)}/cai-dat`),
    ]);
  } catch (e) { toast(`Không mở được: ${errMsg(e)}`, "err"); return; }
  const daCo = new Map((cu?.o ?? []).map((o) => [o.khoa, o] as const));
  // Mẫu CHƯA từng khai báo (cu = null): khách sẽ không thấy ô nào để sửa ngoài sơ đồ → tick sẵn các ô thông dụng (không phải tham số phụ) để Super chỉ cần xem lại rồi Lưu.
  const chuaKhaiBao = cu === null;
  const tickSan = new Set(chuaKhaiBao ? goiY.filter((g) => !g.phu).slice(0, O_TOI_DA).map((g) => g.khoa) : []);
  const nhom = h("select", { "data-testid": "cd-nhom", id: "cd-nhom" }, ...NHOM_MAU.map((n) => h("option", { value: n.ma, selected: n.ma === (cu?.nhom ?? "khac") }, n.ten)));
  const ten = h("input", { type: "text", "data-testid": "cd-ten", id: "cd-ten", maxlength: 80, value: cu?.tenHien ?? "" });
  const moTa = h("textarea", { "data-testid": "cd-mo-ta", id: "cd-mo-ta", maxlength: 200, rows: 2 }, cu?.moTa ?? "");
  const ruiRo = h("select", { "data-testid": "cd-rui-ro", id: "cd-rui-ro" }, ...(Object.keys(RUI_RO_MAU) as RuiRoMau[]).map((r) => h("option", { value: r, selected: r === (cu?.ruiRo ?? "vua") }, `Rủi ro ${RUI_RO_MAU[r]}`)));
  const loi = h("div", { class: "err-box", role: "alert", "data-testid": "cd-loi", hidden: true });
  const dongO = goiY.map((g) => {
    const c = daCo.get(g.khoa);
    const chon = h("input", { type: "checkbox", "data-testid": "cd-o-chon", checked: !!c || tickSan.has(g.khoa), "aria-label": `Cho khách chỉnh ${g.nhan}` });
    const nhan = h("input", { type: "text", "data-testid": "cd-o-nhan", value: c?.nhan ?? g.nhan, maxlength: 60, "aria-label": "Nhãn khách thấy" });
    const min = g.kieu === "so" ? h("input", { type: "number", "data-testid": "cd-o-min", value: String(c?.min ?? g.min ?? ""), "aria-label": "Nhỏ nhất", class: "cd-so" }) : null;
    const max = g.kieu === "so" ? h("input", { type: "number", "data-testid": "cd-o-max", value: String(c?.max ?? g.max ?? ""), "aria-label": "Lớn nhất", class: "cd-so" }) : null;
    // ĐỢT 3b: số cho từng mức (chỉ ô số). Ô chữ (không phải type=number) để Super gõ nhầm chữ vẫn thấy lỗi nêu tên ô từ máy chủ thay vì ô im lặng.
    const muc = g.kieu === "so" ? MUC_DO.map((md) => [md.ma, h("input", { type: "text", inputmode: "numeric", autocomplete: "off", class: "cd-so cd-muc-so", "data-testid": "cd-o-muc", dataset: { muc: md.ma }, value: c?.mucDo?.[md.ma] ?? "", placeholder: g.macDinh, "aria-label": `Mức ${md.ten} — ${g.nhan}` })] as const) : null;
    const el = h("div", { class: "cd-o", "data-testid": "cd-o", dataset: { khoa: g.khoa } },
      h("label", { class: "inline" }, chon, h("b", { class: "wrap" }, g.nhan)),
      h("div", { class: "small muted wrap" }, `dùng ở: ${g.buoc.join(", ")} · đang là “${g.macDinh || "trống"}”`),
      h("div", { class: "row" }, nhan, ...(min && max ? [h("span", { class: "small" }, "từ"), min, h("span", { class: "small" }, "đến"), max] : [])),
      muc ? h("div", { class: "row cd-o-muc-hang", "data-testid": "cd-o-muc-hang" }, h("span", { class: "small muted" }, "Mức độ (trống = mặc định):"),
        ...muc.map(([ma, inp]) => h("label", { class: "cd-muc-cap" }, h("span", { class: "small" }, MUC_DO.find((x) => x.ma === ma)!.ten), inp))) : null);
    return { g, el, chon, lay: (): OCoBan => ({ ...g, nhan: nhan.value.trim(), ...(min && max ? { min: min.value === "" ? undefined : Number(min.value), max: max.value === "" ? undefined : Number(max.value) } : {}),
      ...(muc ? { mucDo: Object.fromEntries(muc.map(([ma, inp]) => [ma, inp.value.trim()])) } : {}) }) };
  });
  const gioiHan = (): void => { const n = dongO.filter((d) => d.chon.checked).length; for (const d of dongO) d.chon.disabled = !d.chon.checked && n >= O_TOI_DA; };
  for (const d of dongO) d.chon.addEventListener("change", gioiHan);
  gioiHan();
  const chinh = dongO.filter((d) => !d.g.phu), phu = dongO.filter((d) => d.g.phu);
  const luu = h("button", { type: "button", class: "pri", "data-testid": "cd-luu", title: "Lưu cách mẫu này hiện trong Kho mẫu của các Boss" }, "Lưu");
  const huy = h("button", { type: "button", "data-testid": "cd-huy", title: "Đóng, không lưu thay đổi" }, "Đóng");
  const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "data-testid": "cd-hop" },
    h("div", { class: "modal km-hop" },
      h("h3", {}, "Hiển thị trong Kho mẫu"),
      loi,
      h("div", { class: "km-o" }, h("label", { for: "cd-nhom" }, "Nhóm (mục tiêu)"), nhom),
      h("div", { class: "km-o" }, h("label", { for: "cd-ten" }, "Tên cho khách"), ten),
      h("div", { class: "km-o" }, h("label", { for: "cd-mo-ta" }, "Mô tả một câu (làm gì, mỗi ngày khoảng bao nhiêu)"), moTa),
      h("div", { class: "km-o" }, h("label", { for: "cd-rui-ro" }, "Mức rủi ro"), ruiRo),
      h("h4", {}, `Ô cho khách chỉnh (tối đa ${O_TOI_DA})`),
      chuaKhaiBao && tickSan.size ? h("p", { class: "info-box", role: "status", "data-testid": "cd-chua-khai-bao" }, `Mẫu này chưa khai báo ô nào nên khách chưa thấy ô nào để sửa ngoài sơ đồ. Đã tick sẵn ${tickSan.size} ô thông dụng — xem lại, bỏ tick ô không cần rồi bấm Lưu để khách thấy.`) : null,
      h("p", { class: "small muted" }, "Tick những gì khách thường cần đổi (từ khoá, số lượng…). Phần còn lại khách không thấy — vẫn sửa được trong “Chỉnh chi tiết”."),
      h("p", { class: "small muted", "data-testid": "cd-muc-goi-y" }, "Ô số: điền số cho từng mức Nhẹ / Vừa / Mạnh (Nhẹ ≤ Vừa ≤ Mạnh, trống = mặc định) — khách chỉ việc chọn mức thay vì nghĩ con số."),
      ...chinh.map((d) => d.el),
      phu.length ? h("details", {}, h("summary", {}, `Tham số khác (${phu.length}) — ít dùng`), ...phu.map((d) => d.el)) : null,
      h("div", { class: "row end" }, huy, luu)));
  const dong = (): void => { wrap.remove(); };
  huy.addEventListener("click", dong);
  wrap.addEventListener("keydown", (e) => { if (e.key === "Escape") dong(); });
  wrap.addEventListener("dong-hop", dong);
  luu.addEventListener("click", () => void busy(luu, "Đang lưu…", async () => {
    loi.hidden = true;
    try {
      await api("PUT", `/api/kb-mau/${encodeURIComponent(mauId)}/cai-dat`, { nhom: nhom.value, tenHien: ten.value, moTa: moTa.value, ruiRo: ruiRo.value, o: dongO.filter((d) => d.chon.checked).map((d) => d.lay()) });
      toast("Đã lưu cách hiển thị trong Kho mẫu");
      dong();
      sauLuu();
    } catch (e) {
      clear(loi);
      const ds = e instanceof ApiError ? ((e.details as { loi?: string[] } | undefined)?.loi ?? [e.message]) : [errMsg(e)];
      loi.append(h("ul", {}, ...ds.map((x) => h("li", {}, x))));
      loi.hidden = false;
    }
  }));
  dongHopTrang();
  document.body.appendChild(wrap);
  ten.focus();
}
